import React from 'react';
import { Grid } from '@mui/material';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import StoresTable from './Table/Table';
import { StoresContextProvider, useStoresContext } from './stores.context';
import { CampaignsContextProvider } from 'pages/Campaigns/campaigns.context';
import { BrandsContextProvider } from 'pages/Brands/brands.context';
import { UsersContextProvider } from 'context/users.context';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import ContentWrapper from 'components/StyledComponents/ContentWrapper';
import CreateStore from './CreateStore';
import ExportCsv from './ExportCsv';

const StoresComponent = (): JSX.Element => {
  const { loading, error } = useStoresContext();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message='There was an error loading Stores' />;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <SectionHeader
          title='Stores'
          actions={
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <ExportCsv />
              <CreateStore />
            </div>
          }
          pageHeader
        />
        <ContentWrapper>
          <StoresTable />
        </ContentWrapper>
      </Grid>
    </Grid>
  );
};

// wrapping component in context provider for full access
const Stores = () => (
  <StoresContextProvider>
    <UsersContextProvider>
      <CampaignsContextProvider>
        <BrandsContextProvider>
          <StoresComponent />
        </BrandsContextProvider>
      </CampaignsContextProvider>
    </UsersContextProvider>
  </StoresContextProvider>
);

export default Stores;
